import {Record} from 'immutable';

const Event = Record({
    id: null,
    name: null,
    selected: false,
    endereco: null,
    local: null,
    valor: null,
    inicio: null,
    fim: null,
    linkCourseware: true,
});

export default Event;



// WEBPACK FOOTER //
// src/domain/Event.js